import React, { useState, useCallback } from 'react';

import { Grid } from 'semantic-ui-react';
import PhotoGallery from 'react-photo-gallery';
import Carousel, { Modal, ModalGateway } from 'react-images';
import * as Constants from '../constants';

export default function Gallery(props) {
    const photos = [
        {
            src: "/img/1.jpg",
            width: 4,
            height: 4
        },
        {
            src: "/img/2.jpg",
            width: 4,
            height: 4
        },
        {
            src: "/img/3.jpg",
            width: 4,
            height: 4
        },
        {
            src: "/img/4.jpg",
            width: 5,
            height: 3
        },
        {
            src: "/img/5.jpg",
            width: 4,
            height: 4
        },
        {
            src: "/img/6.jpg",
            width: 4,
            height: 4
        },
        {
            src: "/img/7.jpg",
            width: 5,
            height: 3
        },
        {
            src: "/img/8.jpg",
            width: 5,
            height: 3
        },
        {
            src: "/img/9.jpg",
            width: 5,
            height: 3
        },
        {
            src: "/img/10.jpg",
            width: 5,
            height: 4
        },
        {
            src: "/img/11.jpg",
            width: 4,
            height: 4
        },
        {
            src: "/img/12.jpg",
            width: 4,
            height: 4
        },
        {
            src: "/img/13.jpg",
            width: 4,
            height: 4
        },
        {
            src: "/img/14.jpg",
            width: 4,
            height: 4
        },
        {
            src: "/img/15.jpg",
            width: 4,
            height: 4
        }
    ];

    const init = {
        index: 0,
        open: false
    };

    const [current, setCurrent] = useState(init);

    const openLightBox = useCallback((event, { photo, index }) => {
        setCurrent({ index, open: true });
    }, []);

    const closeLightBox = () => {
        setCurrent({ index: 0, open: false });
    };

    return (
        <React.Fragment>
            <Grid stackable padded>
                <Grid.Row style={{marginTop: "1em", marginBottom: "1em"}}>
                    <Grid.Column width={16} textAlign="center">
                        <h1 style={Constants.Header}>Gallery - &nbsp;<em>Click to Enlarge</em></h1>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column only="computer" width={1} textAlign="center"></Grid.Column>
                    <Grid.Column only="computer" width={14} textAlign="center">
                        <PhotoGallery photos={photos} onClick={openLightBox} />
                    </Grid.Column>
                    <Grid.Column only="computer" width={1} textAlign="center"></Grid.Column>
                    <Grid.Column only="tablet mobile" width={16} textAlign="center">
                        <PhotoGallery photos={photos} onClick={openLightBox} />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <ModalGateway>
                {current.open ? (
                    <Modal onClose={closeLightBox} >
                        <Carousel
                            currentIndex={current.index}
                            views={photos.map(x => ({
                                ...x,
                                srcset: x.srcSet
                            }))}
                        />
                    </Modal>
                ) : null}
            </ModalGateway>
        </React.Fragment>
    )
}